import CommentBoxAvatar from './CommentBoxAvatar';
import CommentBoxAvatarV2 from '../../lego.editor_comment/CommentBoxAvatar';
import withFeatureBranch from '@wix/da-react-context/pkg/flags/withFeatureBranch';
export default withFeatureBranch({
    editor_comment: CommentBoxAvatarV2
})(CommentBoxAvatar);

//# sourceMappingURL=index.js.map